"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedlifestyle = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedlifestyle` : '') + (description ? ` desc-brandedlifestyle` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedlifestyle"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedlifestyle"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.18 29.224L46.19 34.2887C45.55 34.6469 45.24 35.3932 45.44 36.0897L48.19 45.9903C48.52 47.1744 47.42 48.2689 46.22 47.9405L36.28 45.2042C35.57 45.0152 34.83 45.3236 34.47 45.9604H21.52C21.16 45.3236 20.41 45.0152 19.71 45.2042L9.77 47.9405C8.58 48.2689 7.48 47.1843 7.8 45.9903L10.55 36.0897C10.74 35.3932 10.43 34.6469 9.8 34.2887L0.81 29.224C-0.27 28.6171 -0.27 27.0748 0.81 26.4678L9.8 21.4031C10.43 21.0449 10.74 20.3086 10.55 19.6021L7.8 9.71149C7.47 8.51746 8.57 7.42292 9.77 7.75128L19.71 10.4976C20.42 10.6866 21.16 10.3782 21.52 9.74134L26.61 0.805974C27.22 -0.268658 28.78 -0.268658 29.39 0.805974L34.48 9.74134C34.84 10.3782 35.59 10.6866 36.29 10.4976L46.23 7.75128C47.42 7.42292 48.52 8.51746 48.2 9.71149L45.45 19.6021C45.26 20.3086 45.57 21.0449 46.2 21.4031L55.19 26.4678C56.27 27.0748 56.27 28.6171 55.19 29.224H55.18Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28 45.5C37.9394 45.5 46 37.4394 46 27.5C46 17.5606 37.9394 9.5 28 9.5C18.0606 9.5 10 17.5606 10 27.5C10 37.4394 18.0606 45.5 28 45.5Z",
    fill: "#FFEBC7"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.0644 46.3067C37.9716 46.3067 46 38.0353 46 27.8284C46 22.9893 44.1987 18.5992 41.2449 15.3167C33.6136 24.8751 24.8007 33.3559 15 40.4998C18.2734 44.0817 22.9122 46.3167 28.0547 46.3167L28.0644 46.3067Z",
    fill: "#FFDC9C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M54.9098 34H1.09019C0.488097 34 0 34.4911 0 35.0969V48.9031C0 49.5089 0.488097 50 1.09019 50H54.9098C55.5119 50 56 49.5089 56 48.9031V35.0969C56 34.4911 55.5119 34 54.9098 34Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.09019 34H54.9098C55.5099 34 56 34.5444 56 35.2111V41H0V35.2111C0 34.5444 0.490088 34 1.09019 34Z",
    fill: "#F8985A"
  }));
};
var _default = exports.default = brandedlifestyle;